module.exports = __webpack_public_path__ + "site/img/117.09812533.jpg";